import { AccountType } from '@liquidbudget/common';

export interface Bucket {
  id: string;
  name: string;
  assigned: number;
  outflow: number;
}

export interface Category {
  id: string;
  name: string;
  notes: string;
  buckets: Bucket[];
}

export interface Transaction {
  date: string;
  payee: string;
  account: string;
  accountType: AccountType;
  category: string;
  bucket: string;
  inflow?: number;
  outflow?: number;
}

export const budgetData: Category[] = [
  {
    id: '1',
    name: 'Discretionary',
    notes: 'Non-essential spending',
    buckets: [
      { id: '1', name: 'Groceries', assigned: 500, outflow: -200 },
      { id: '2', name: 'Dining Out', assigned: 300, outflow: 0 },
      { id: '3', name: 'Shopping', assigned: 150, outflow: -250 },
    ],
  },
  {
    id: '2',
    name: 'Expenses',
    notes: 'Essential living expenses',
    buckets: [
      { id: '4', name: 'Mortgage', assigned: 2500, outflow: -2500 },
      { id: '5', name: 'Insurance', assigned: 200, outflow: 0 },
      { id: '6', name: 'Electricity', assigned: 200, outflow: 0 },
      { id: '7', name: 'Water', assigned: 100, outflow: 0 },
      { id: '8', name: 'Phone', assigned: 80, outflow: 0 },
    ],
  },
  {
    id: '3',
    name: 'Savings',
    notes: 'Future planning',
    buckets: [
      { id: '9', name: 'Emergency Fund', assigned: 500, outflow: 0 },
      { id: '10', name: 'Retirement', assigned: 1000, outflow: 0 },
      { id: '11', name: 'Vacation', assigned: 200, outflow: 0 },
      { id: '12', name: 'Christmas', assigned: 100, outflow: 0 },
    ],
  },
];

export const transactionData: Transaction[] = [
  {
    date: '2024-12-15',
    account: 'Checking',
    accountType: AccountType.CHECKING,
    payee: 'Mortgage Co.',
    category: 'Expenses',
    bucket: 'Mortgage',
    inflow: 0,
    outflow: 2500,
  },
  {
    date: '2024-12-15',
    account: 'Cash',
    accountType: AccountType.CASH,
    payee: 'Try n Save',
    category: 'Discretionary',
    bucket: 'Groceries',
    inflow: 0,
    outflow: 200,
  },
  {
    date: '2024-12-15',
    account: 'Checking',
    accountType: AccountType.CHECKING,
    payee: 'Amazon.com',
    category: 'Discretionary',
    bucket: 'Shopping',
    inflow: 0,
    outflow: 250,
  },
];
